import Moment from 'moment'
import Config from './config'
import { $trackPost,$post } from './http'
import Api from './api'
import Filters from './filters'
import Wx from 'weixin-js-sdk'

export default {
    Attribute: {
        UA: window.navigator.userAgent,
        // 判断是否是微信
        isWeixin() {
            var ua = this.UA
            if (/MicroMessenger/i.test(ua)) {
                return true
            }
            return false
        },
        // 判断是否是QQ
        isQQ() {
            var ua = this.UA
            if (/QQ\//.test(ua)) {
                return true
            }
            return false
        },
        // 判断是否是Android
        isAndroid() {
            var ua = this.UA
            if (/android/i.test(ua)) {
                return true
            }
            return false
        }
    },
    // 裁切图片
    slimImg(img, w) {
        if (img) {
            const imgParams = `x-image-process=image/resize,m_fixed,w_${w}/quality,q_80`
            return img.indexOf('?') > -1 ? `${img}&${imgParams}` : `${img}?${imgParams}`
        } else {
            return ''
        }
    },
    // 跳转到对应pc页面
    httpToPc(pathname, lan) {
        if (!/Android|webOS|iPhone|iPod|BlackBerry|Windows Phone|Harmony/i.test(this.Attribute.UA)) {
            let url = lan !== 'en' ? Config.pcDomain : Config.pcEnDomain
            for (const key in Config.pcPage) {
                if (pathname.indexOf(`/${key}`) > -1) {
                    const pcPath = Config.pcPage[key]
                    const pathnameArr = pathname.split('/')
                    const id = pathnameArr.length > 2 ? pathname.split(pathnameArr[1])[1] : ''
                    const expireSignArr = window.location.href.match(/expireSign=([^&]*)(&|$)/)
                    const expireSign = expireSignArr && expireSignArr[1]
                    url = pcPath.indexOf('.html') > -1 ? url.split('/#')[0] : url
                    url = !id ? `${url}/${Config.pcPage[key]}` : `${url}/${Config.pcPage[key]}${id}`
                    expireSign && (url = `${url}?expireSign=${expireSign}`)
                    break
                }
            }
            window.location.href = url
        }
    },
    // 分享
    pageShare() {
        Api.getHomeShare({}).then((data) => {
            data && data.share && this.onshare({
                shareTitle: data.share.shareTitle,
                shareBrief: data.share.shareBrief,
                shareImg: data.share.shareImg,
                shareUrl: window.location.href
            })
        })
    },
    // 判断是不是超链接
    isHyperlinks(url) {
        return /^http(s)?:\/\/(.*)?/.test(url)
    },
    // 分享
    onshare(obj) {
        const shareDate = {
                title: obj.shareTitle,
                desc: obj.shareBrief || obj.shareTitle, // '受理、协助处置网民对互联网违法和不良信息的举报', // obj.shareBrief || obj.shareTitle,
                imgUrl: obj.shareImg,
                link: obj.shareUrl
            }
            // 微信分享
        if (this.Attribute.isWeixin()) {
            this.setWeChatConf().then(() => {
                    this.wxOnshare(shareDate)
                })
                // qq分享
        } else if (this.Attribute.isQQ()) {
            if (window.mqq && window.mqq.data && window.mqq.data.setShareInfo) {
                window.mqq.data.setShareInfo({
                    title: shareDate.title,
                    share_url: shareDate.link,
                    image_url: shareDate.imgUrl,
                    desc: shareDate.desc
                })
            } else {
                this.loadjs('https://open.mobile.qq.com/sdk/qqapi.js?_bid=152').then(() => {
                    window.mqq.data.setShareInfo({
                        title: shareDate.title,
                        share_url: shareDate.link,
                        image_url: shareDate.imgUrl,
                        desc: shareDate.desc
                    })
                })
            }
        }
    },
    // 微信配置
    setWeChatConf() {
        return new Promise((resolve, reject) => {
            // Api.getWeChatConf({
            //     url: window.location.href.split('#')[0]
            // }).then(data => {
            $post('https://piyao-api.thecover.cn/wap/counterRumour/weixin/getConf', { url: window.location.href.split('#')[0] }, {}).then(data => {
                const D = data.data
                Wx.config({
                    debug: false,
                    appId: D.appId,
                    timestamp: D.timestamp,
                    nonceStr: D.nonceStr,
                    signature: D.signature,
                    jsApiList: [
                        'onMenuShareTimeline',
                        'onMenuShareAppMessage',
                        'onMenuShareQQ',
                        'onMenuShareWeibo',
                        'onMenuShareQZone',
                        'previewImage'
                    ]
                })
                resolve()
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 微信分享
    wxOnshare(obj) {
        Wx.ready(() => {
            // 分享到朋友圈
            Wx.onMenuShareTimeline(obj)
                // 分享给朋友
            Wx.onMenuShareAppMessage(obj)
                // 分享到QQ
            Wx.onMenuShareQQ(obj)
                // 分享到腾讯微博
            Wx.onMenuShareWeibo(obj)
                // 分享到QQ空间
            Wx.onMenuShareQZone(obj)
        })
    },
    // 动态加载js
    loadjs(src) {
        return new Promise((resolve, reject) => {
            const scriptNode = document.createElement('script')
            scriptNode.setAttribute('type', 'text/javascript')
            scriptNode.setAttribute('src', src)
            document.body.appendChild(scriptNode)
                // IE 判断
            if (scriptNode.readyState) {
                scriptNode.onreadystatechange = () => {
                    if (scriptNode.readyState === 'complete' || scriptNode.readyState === 'loaded') {
                        resolve()
                    }
                }
            } else {
                scriptNode.onload = () => {
                    resolve()
                }
            }
        })
    },
    // 上拉加载数据
    pullLoadData(fn) {
        const app = document.querySelector('#app')
        app.addEventListener('scroll', () => {
            const winH = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
            if (app.scrollTop + winH + 10 > app.scrollHeight) {
                fn()
            }
        }, false)
    },
    // 倒计时
    countDown(endTime, serverTime) {
        const nowTime = serverTime ? Moment(serverTime) : Moment()
        const size = Moment.duration(Moment(endTime) - nowTime, 'ms')
        const days = size.get('days')
        const hours = size.get('hours')
        const mins = size.get('minutes')
        const secs = size.get('seconds')
        if (Moment(endTime) - nowTime < 0) {
            return null
        } else {
            return [Filters.number.numToTens(days), Filters.number.numToTens(hours), Filters.number.numToTens(mins), Filters.number.numToTens(secs)]
        }
    },
    // 埋点
    track(type, param) {
        const userInfo = localStorage.getItem('userInfo')
        const userId = (userInfo && JSON.parse(userInfo).userId) || ''
        const deviceId = this.getDeviceId()
        return new Promise((resolve, reject) => {
            $trackPost(Config.trackApiUrl, {
                applicationId: 'sztf_expo', // 必填， 固定值， 后面确定
                eventType: type, // 必填， 枚举。 有load(页面加载), share(分享),click(按钮点击)
                eventTime: new Date().getTime(), // 必填， 时间戳
                activeId: 'sztf_expozkibwscyvqqhwszf', // 必填， 固定值， easy那边最终确定
                distinctId: userId || deviceId, // 必填， 用来关联用户的基本信息，可以游客随机，但是尽量保证一次打开使用同一个而不变，有设备的用设备id， 登录之后用userid。
                uri: window.location.href, // 必填， 页面的URI
                deviceId: deviceId, // 选填.  用来关联APP的设备。
                sessionId: '', // 选填， 尽量保证每次会话不同
                eventParam: param // 具体的参数的值
            }).then((res) => {
                resolve(res)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    getDeviceId() {
        let did = localStorage.getItem('COVER_KBH_DID')
        if (!did) {
            did = 'other-' + new Date().getTime().toString(36) + '-' + Math.random().toString(36).substr(2, 8)
            localStorage.setItem('COVER_KBH_DID', did)
        }
        return did
    },
    validateInput(val) {
         // 以换行符分隔输入的内容
         const lines = val.split('\n');

         // 遍历每一行，检查是否以'http://'或'https://'开头
         for (let line of lines) {
             if (!line.startsWith('http://') && !line.startsWith('https://')) {
                 return false ; // 如果有一行不符合条件，返回false
             }
         }
         return true; // 如果所有行都符合条件，返回true
    },
    validateInputText(val) {
        function checkIfEmpty(input) {
            // 去掉字符串两端的空格
            let trimmedInput = input.trim();
        
            // 检查去掉空格后的字符串是否为空
            if(trimmedInput.length === 0) {
                return true; // 字符串为空
            } else {
                return false; // 字符串不为空
            }
        }
        // 以换行符分隔输入的内容
        const lines = val.split('\n');
        let errList = []
        // 遍历每一行，检查是否以'http://'或'https://'开头
        for (let line of lines) {
            if (!checkIfEmpty(line) && !line.toLowerCase().startsWith('http://') && !line.toLowerCase().startsWith('https://')) {
                errList.push(line) ; // 如果有一行不符合条件，返回false
            }
        }
        if(errList.length){
           return `输入网址有误，请确认后重新输入，错误网址为：${errList.join('；')}`
        }else{
           return ''; // 如果所有行都符合条件，返回true
        }
   }
}